<template>
  <div class="video-js__wrapper">
    <v-progress-circular
      v-if="!loaded"
      indeterminate
      class="video-js__loader"
      color="white"
    />
    <video
      ref="videoPlayer"
      class="video-js"
      playsinline
      autoplay
      muted
      loop
    />
  </div>
</template>

<script lang="ts">
import videojs from 'video.js'
import { Vue, Component, Prop, Watch } from 'vue-facing-decorator'

@Component({})
export default class VideoPlayer extends Vue {
  @Prop({}) options!: any
  @Prop({ type: Boolean }) active!: boolean
  loaded = false
  player = null

  @Watch('active')
  onActiveChange (newVal) {
    const method = newVal ? 'play' : 'pause'
    this.player[method]()
  }

  mounted () {
    this.player = videojs(this.$refs.videoPlayer as HTMLElement, this.options, () => {
      this.loaded = true
    })

    if (this.active) {
      this.player.play()
    }
  }

  beforeUnmount () {
    if (this.player) {
      this.player.dispose()
    }
  }
}
</script>

<style lang="scss">
@import 'https://unpkg.com/video.js/dist/video-js.min.css';
  .video-js__wrapper {
    height: 100%;
    width: 100%;
  }
  .video-js__loader {
    position: absolute;
    top: calc(50% - 1rem);
    left: calc(50% - 1rem);
  }
  .video-js {
    height: 100%;
    width: 100%;
  }

  .vjs-tech {
    object-fit: cover !important;
  }

  .vjs-waiting {
    background: transparent;
  }

  video::-webkit-media-controls-panel,
  video::-webkit-media-controls-panel-container,
  video::-webkit-media-controls-start-playback-button {
    display:none !important;
    -webkit-appearance: none;
  }
</style>
